import { BtnLikePost } from "@/components/Community/LikeBtn";
import Reply from "@/components/Community/Reply";
import Link from "next/link";
import { createContext, useRef, useState, useContext, useEffect } from "react";
import { useUser } from "@auth0/nextjs-auth0";
import Image from "next/image";
import IconShare from "@/images/iconShare.svg";
import IconSeek from "@/images/iconSeek.svg";
import moment from "moment";
import { BsArrowLeft, BsDot } from "react-icons/bs";
import { MdClose, MdReply } from "react-icons/md";
import { useEditor, EditorContent } from '@tiptap/react'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Mention from '@tiptap/extension-mention';
import Placeholder from '@tiptap/extension-placeholder'
import suggestion from '@/components/Community/Editor/suggestion';
import { BsThreeDotsVertical } from "react-icons/bs";
import { Form, Modal, OverlayTrigger, Spinner } from "react-bootstrap";
import { FaHeart } from "react-icons/fa";
import { callBackendApi } from "@/utils/common";
import { AppContext } from "@/pages/_app";
export const PostContext = createContext();
import { useRouter } from "next/router";
import Avatar from "react-avatar";
import TiptapLink from '@tiptap/extension-link';
import HeadComponent from '@/components/HeadComponent';
import CustomBody from "@/components/Tiptap/CustomBody";





const Post = (props) => {
    const { loggedInUser, popoverLoginAlert, handleRedirectToLoginPage, handleRedirectToSignupPage } = useContext(AppContext);
    const formReply = useRef();
    const [post, setPost] = useState(props.post);
    const [replies, setReplies] = useState(props.post.replies);
    const [replyBody, setReplyBody] = useState(null);
    const [replyBodyText, setReplyBodyText] = useState(null);
    const [showModalEditPost, setShowModalEditPost] = useState(false);
    const [editPostBody, setEditPostBody] = useState(post.body);
    const [editPostBodyText, setEditPostBodyText] = useState(post.bodyText || "");
    const formEditPost = useRef();
    const [errorEditPost, setErrorEditPost] = useState(null);
    const [editPostTitle, setEditPostTitle] = useState("");
    const [loadingEditPostForm, setLoadingEditPostForm] = useState();
    const router = useRouter();
    const [loadingReportPost, setLoadingReportPost] = useState(false);
    const [showModalReportPost, setShowModalReportPost] = useState(false);
    const [loadingDeletePost, setLoadingDeletePost] = useState(false);
    const [showModalDeletePost, setShowModalDeletePost] = useState(false);
    const [currentDeletePostID, setCurrentDeletePostID] = useState(null);
    const [postDeletedSuccess, setPostDeletedSuccess] = useState(false);
    const [loadingDeleteReply, setLoadingDeleteReply] = useState(false);
    const [showModalDeleteReply, setShowModalDeleteReply] = useState(false);
    const [currentDeleteReplyID, setCurrentDeleteReplyID] = useState(null);
    const [reportType, setReportType] = useState(null);
    const [showLikesModal, setShowLikesModal] = useState(false);
    const [loadingLikesModal, setLoadingLikesModal] = useState(false);
    const [likesData, setLikesData] = useState(null);
    const [replyError, setReplyError] = useState(null);


    


    // on click likes count button
    const handleShowLikesModal = async () => {
        setLoadingLikesModal(true);
        setShowLikesModal(true);
        // get all likes data of this post
        await callBackendApi({
            method: "get",
            url: `/community/likes/post/${post._id}`
        }).then(response => {
            setLikesData(response.data.data.map(item => item.userId))
        })
        setLoadingLikesModal(false);
    }

    // delete post section
    const confirmDeletePost = (_id) => {
        setCurrentDeletePostID(_id);
        setShowModalDeletePost(true);
    }
    const handleDeletePost = async () => {
        setLoadingDeletePost(true);
        await callBackendApi({
            method: "delete",
            url: `/community/posts/${currentDeletePostID}`
        }).then(response => {
            if (response.data.success === true && response.data.data.isDeleted === true) {
                setPostDeletedSuccess(true);
                router.push("/community");
            } else {
                alert("Unable to delete post!");
            }
        }).catch(err => alert("Something went wrong!"))
        setLoadingDeletePost(false);
    }


    // delete reply section
    const confirmDeleteReply = (_id) => {
        setCurrentDeleteReplyID(_id);
        setShowModalDeleteReply(true);
    }

    const handleDeleteReply = async () => {
        setLoadingDeleteReply(true);
        await callBackendApi({
            method: "delete",
            url: "/community/posts/" + post._id + "/replies/" + currentDeleteReplyID
        })
            .then((response) => {
                if (response.data.success === true && response.data.data.isDeleted === true) {
                    const replyIndex = replies.findIndex(item => item._id === currentDeleteReplyID);
                    // if this reply dont have any subrelies delete this from list
                    if (replies[replyIndex].countReplies === 0) {
                        replies.splice(replyIndex, 1);
                    } else {
                        replies[replyIndex].isDeleted = true;
                        replies[replyIndex].body = "This reply is deleted by user.";
                    }
                    // replies.map((item, index) => {
                    //     if (item._id === currentDeleteReplyID) {
                    //         replies[index].isDeleted = true;
                    //     }
                    //     replies[index].isDeleted = true;
                    // })
                    setShowModalDeleteReply(false);
                }
            })
            setLoadingDeleteReply(false);
    }



    const editPostEditor = useEditor({
        editorProps: {
            attributes: {
                class: 'no-focus-outline',
            },
        },
        extensions: [
            Placeholder.configure({
                placeholder: 'My Custom Placeholder',
            }),
            Document,
            Paragraph.configure({
                HTMLAttributes: {
                    class: 'm-0',
                },
            }),
            Text,
            TiptapLink.configure({
                openOnClick: false
              }),
            Mention.configure({
                HTMLAttributes: {
                    class: 'mention mds-text-primary',
                },
                suggestion,
                renderLabel({ options, node }) {
                    return `${options.suggestion.char}${node.attrs.id.companyName ?? node.attrs.id}`
                }
            }),
        ],
        onUpdate: ({ editor }) => {
            setEditPostBody(editor.getJSON());
            setEditPostBodyText(editor.getText());
        }
    })

    const handleShowModalEditPost = () => {
        setEditPostTitle(post.title);
        editPostEditor.commands.setContent(post.body);
        setShowModalEditPost(true);
    }

    const handleHideModalEditPost = () => {
        setShowModalEditPost(false);
    }

    const handleSubmitFormEditPost = async () => {
        setErrorEditPost(null);
        setLoadingEditPostForm(true);
        const formData = new FormData(formEditPost.current);
        formData.append('body', JSON.stringify(editPostBody));
        formData.append('bodyText', editPostBodyText);
        try {
            // check if post title is not empty
            if (editPostTitle.trim() === "") {
                throw new Error("Post title cannot be empty!");
            }

            const response = await callBackendApi({
                method: "put",
                url: "/community/posts/" + post._id,
                data: formData
            })

            setPost(response.data.data);
            setEditPostBody(response.data.data);
            handleHideModalEditPost();
            editPostEditor.commands.clearContent(true);

        } catch (error) {
            console.log(error.response)
            if (error.response) {
                setErrorEditPost(error.response.data.data.message);
            }
        }
        setLoadingEditPostForm(false);
    }

    // create reply section
    const [loadingReplyForm, setLoadingReplyForm] = useState();

    const newReplyEditor = useEditor({
        editorProps: {
            attributes: {
                class: 'no-focus-outline',
            },
        },
        extensions: [
            Placeholder.configure({
                placeholder: 'My Custom Placeholder',
            }),
            Document,
            Paragraph.configure({
                HTMLAttributes: {
                    class: 'm-0',
                },
            }),
            Text,
            TiptapLink.configure({
                openOnClick: false
              }),
            Mention.configure({
                HTMLAttributes: {
                    class: 'mention mds-text-primary',
                },
                suggestion,
                renderLabel({ options, node }) {
                    return `${options.suggestion.char}${node.attrs.id.companyName ?? node.attrs.id}`
                }
            }),
        ],
        onUpdate: ({ editor }) => {
            setReplyBody(editor.getJSON());
            setReplyBodyText(editor.getText());
        }
    })

    const handleSubmitFormReply = async (e) => {
        e.preventDefault();
        setReplyError(null)
        setLoadingReplyForm(true);
        try {
            // check if reply body is empty
            if (replyBodyText === null || replyBodyText.trim() === "") {
                throw new Error("Reply cannot be empty");
            }
            const formData = new FormData(formReply.current);
            formData.append('body', JSON.stringify(replyBody));
            formData.append('bodyText', replyBodyText);
            const response = await callBackendApi({
                method: "post",
                url: "/community/posts/" + post._id + "/replies",
                data: formData
            }).catch(error => {
                // show error message if it come from server
                const errorMessage = error.response.data.data.message || "Something went wrong while submiting reply.";
                throw new Error(errorMessage);
            })
            if (response.data.success === true) {
                let newReply = response.data.data;
                newReply.isLiked = false;
                newReply.likes = [];
                newReply.recentReplies = [];
                setReplies([newReply, ...replies]);
                newReplyEditor.commands.clearContent(true);
            } else {
                throw new Error("Something went wrong while submiting reply.");
            }
        } catch (error) {
            setReplyError(error.message);
        }
        setLoadingReplyForm(false);
    }




    // report post section
    const handleShowModalReportPost = () => {
        setShowModalReportPost(true);
    }
    const handleHideModalReportPost = () => {
        setShowModalReportPost(false);
    }
    const formReportPost = useRef();
    const handleSubmitFormReportPost = async (e) => {
        e.preventDefault();
        setLoadingReportPost(true);
        const reportFormData = new FormData(formReportPost.current);
        reportFormData.append('postId', post._id);
        const response = await callBackendApi({
            method: "post",
            url: "/community/report",
            data: reportFormData
        });
        if (response.data.success) {
            post.isUserReported = true;
            post.flags.reported = true;
            handleHideModalReportPost();
        }
        setLoadingReportPost(false);
    }


    // const commentRef = useRef();
    // const focusComment = () => {
    //     commentRef.foucs()
    // }

    // post like button section
    const [isLiked, setIsUserLiked] = useState(post.isLiked); // post liked by current user
    const [countLikes, setCountLikes] = useState(post.countLikes); // total likes count
    const [loadingBtnLike, setLoadingBtnLike] = useState(false);

    const handleClickLikePostBtn = async () => {
        setLoadingBtnLike(true);
        if (isLiked) {
            // unlike function
            const response = await callBackendApi({
                method: "delete",
                url: "/community/likes/post/" + post._id
            })
            if (response.data.success == true) {
                setIsUserLiked(false);
                setCountLikes(countLikes - 1);
            } else {
                setIsUserLiked(true);
            }
        } else {
            const response = await callBackendApi({
                method: "post",
                url: "/community/likes/post/" + post._id
            })
            if (response.data.success == true) {
                setIsUserLiked(true);
                setCountLikes(countLikes + 1);
            } else {
                setIsUserLiked(false);
            }
        }
        setLoadingBtnLike(false);
    }





    return (
            <PostContext.Provider value={{ confirmDeleteReply }}>
            {
                // if post not found due to post url is wrong
                !post.hasOwnProperty("isDeleted") ?
                    <div className="container py-5 ">
                        <p className="text-muted h4 text-center m-0 mb-3">Post not found!</p>
                        <div className="text-center">
                            <Link href="/community">
                                <a className="mds-text-primary"><BsArrowLeft /> Go back to Community</a>
                            </Link>
                        </div>
                    </div>
                    :
                    <>
                        {

                            // if post found but deleted by user
                            post.isDeleted === true
                                ?
                                <div className="container py-5">
                                    <p className="text-muted h4 text-center m-0 mb-3">This Post was deleted!</p>
                                    <div className="text-center">
                                        <Link href="/community">
                                            <a className="mds-text-primary"><BsArrowLeft /> Go back to Community</a>
                                        </Link>
                                    </div>
                                </div>
                                :
                                    <>
                                        <HeadComponent
                                            title={post.title + " | MDS Community"}
                                        />
                                        <div className="mds-bg-primary-muted">
                                            <div className="container d-none d-lg-block">
                                                <nav className="py-3">
                                                    <ol className="breadcrumb mds-breadcrumb">
                                                        <li className="breadcrumb-item">
                                                            <Link href="/community"><a>MDS Community</a></Link>
                                                        </li>
                                                        <li className="breadcrumb-item active">
                                                            Posts
                                                        </li>
                                                    </ol>
                                                </nav>
                                            </div>
                                            <div className="container pt-2 pb-5">
                                                <div className="d-flex justify-content-between align-items-center gap-lg-3 mb-3">
                                                    <div className="d-flex flex-fill  flex-column flex-lg-row align-items-start align-items-lg-center gap-2 ">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className="d-flex gap-2 align-items-center">
                                                                {post.userId.imageUrl ?
                                                                    <Image layout="fixed" className="border mds-border-primary-light rounded-circle" src={post.userId.imageUrl} width={24} height={24} />
                                                                    :
                                                                    <Avatar name={post.userId.fullName} size={24} round />
                                                                }
                                                                <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-lg-2">
                                                                <span className="mds-fw-md text-capitalize mds-text-dark text-nowrap">
                                                                    <Link href={`/u/${post.userId.username}`}>
                                                                        <a className="mds-text-primary">
                                                                            {post.userId.fullName}
                                                                        </a>
                                                                    </Link>
                                                                </span>
                                                                    {/* <span className="text-muted">Product Designer @cliff.ai</span> */}
                                                                </div>
                                                            </div>
                                                            <div className="d-none d-lg-inline-block"><BsDot style={{ color: "#FDDECC" }} /></div>
                                                        </div>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className="d-flex gap-1 align-items-center">
                                                                <span className="align-items-center d-flex">{post.postType === 'seek' ? <Image layout="fixed" src={IconSeek} width={22} height={22} /> : <Image layout="fixed" width={22} height={22} src={IconShare} />}</span>
                                                                <span className=" mds-fw-md mds-text-dark">{post.postType}</span>
                                                            </div>
                                                            <div className="d-none d-lg-inline-block"><BsDot style={{ color: "#FDDECC" }} /></div>
                                                            <div className="mds-fw-sm text-muted d-none d-lg-inline-block">
                                                                {moment(post.createdAt).format('MMM DD, YYYY')}
                                                            </div>
                                                        </div>
                                                        {loggedInUser &&
                                                            <div className="ms-auto d-none d-lg-inline-flex">
                                                                <div className="mds-dropdown">
                                                                    <button id="dropdownId" type="button" className="mds-fs-5 px-1 mds-rounded-sm mds-btn-light-primary" data-bs-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false">
                                                                        <BsThreeDotsVertical />
                                                                    </button>
                                                                    <div className="dropdown-menu" aria-labelledby="dropdownId">
                                                                        {post.userId.email === loggedInUser?.email &&
                                                                            <>
                                                                                <button onClick={handleShowModalEditPost} className="dropdown-item" >Edit</button>
                                                                                <button onClick={() => confirmDeletePost(post._id)} className="dropdown-item" >Delete</button>
                                                                            </>
                                                                        }
                                                                        {post.userId.email !== loggedInUser?.email && (post.isUserReported ?
                                                                            <span className="dropdown-item-text text-muted">Reported</span>
                                                                            :
                                                                            <button onClick={handleShowModalReportPost} className="dropdown-item" >Report</button>)
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                </div>
                                            </div>
                                            <div className="mb-4">
                                                <h1
                                                    id="postTitle"
                                                    className="mds-fs-lg mds-fw-lg m-0 mb-2">{post.title}</h1>
                                                <p className="m-0 mds-fw-sm mds-fs-p mds-text-dark">
                                                    <CustomBody body={post.body} />
                                                    {post.edited === true &&
                                                        <span className="text-muted small"> - Edited </span>
                                                    }
                                                </p>
                                            </div>
                                                <div className="">
                                                    <div className="d-flex gap-2 align-items-center">
                                                        <OverlayTrigger trigger={!loggedInUser && "click"} placement="top" rootClose overlay={popoverLoginAlert} >
                                                            <button disabled={loadingBtnLike} onClick={() => loggedInUser && handleClickLikePostBtn()}
                                                                className={(isLiked && " active ") + " btn pe-0 "}>
                                                                <FaHeart width={40} className={" mds-btn-icon mds-text-primary " + (isLiked && " active ")} />
                                                            </button>
                                                        </OverlayTrigger>
                                                        <button className="btn ps-0 mds-text-primary"
                                                            onClick={handleShowLikesModal}
                                                            disabled={loadingBtnLike}
                                                        >
                                                            {loadingBtnLike ?
                                                                <Spinner animation="border" size="sm" />
                                                                :
                                                                <span className="mds-fs-4 mds-fw-md">{countLikes}</span>
                                                            }
                                                        </button>
                                                        {loggedInUser &&
                                                            <div className="ms-auto d-lg-none">
                                                                <div className="mds-dropdown">
                                                                    <button id="dropdownId" type="button" className="mds-fs-5 px-1 mds-rounded-sm mds-btn-light-primary" data-bs-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false">
                                                                        <BsThreeDotsVertical />
                                                                    </button>
                                                                    <div className="dropdown-menu" aria-labelledby="dropdownId">
                                                                        {post.userId.email === loggedInUser?.email &&
                                                                            <>
                                                                                <button onClick={handleShowModalEditPost} className="dropdown-item" >Edit</button>
                                                                                <button onClick={handleDeletePost} className="dropdown-item" >Delete</button>
                                                                            </>
                                                                        }
                                                                        {post.flags.reported ?
                                                                            <span className="dropdown-item-text text-muted">Reported</span>
                                                                            :
                                                                            <button onClick={handleShowModalReportPost} className="dropdown-item" >Report</button>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="container py-5">
                                        {loggedInUser ?
                                            <div id="mds-form" className="d-flex flex-column gap-3">
                                                <div className="mds-fw-lg mds-fs-lg pb-lg-2 pb-1 pt-lg-2">Give advice</div>
                                                <div className="mb-lg-3 d-flex flex-column flex-lg-row align-items-stretch align-items-lg-start gap-3">
                                                    <div className="d-none d-lg-inline">
                                                        {loggedInUser.imageUrl ?
                                                            <Image layout="fixed" className="border mds-border-primary-light rounded-circle" src={loggedInUser.imageUrl} width={30} height={30} />
                                                            :
                                                            <Avatar name={loggedInUser.fullName} size={30} round />
                                                        }
                                                    </div>
                                                    <div className="flex-fill">
                                                        <form className="mds-form" ref={formReply} onSubmit={handleSubmitFormReply}>
                                                            <div className="d-flex flex-column gap-1 alig-items-start">
                                                                <div className="border flex-grow-1 mds-rounded-md mds-border-primary-light">
                                                                    <div className="d-lg-none border-bottom mds-border-primary-light p-2">
                                                                        {loggedInUser.imageUrl ?
                                                                            <Image layout="fixed" className="border mds-border-primary-light rounded-circle" src={loggedInUser.imageUrl} width={30} height={30} />
                                                                            :
                                                                            <Avatar name={loggedInUser.fullName} size={30} round />
                                                                        }
                                                                    </div>
                                                                    <div className="d-flex flex-column gap-1 p-2">
                                                                        <EditorContent id="mdf-form-input" editor={newReplyEditor} />
                                                                        <div className="d-grid d-lg-block text-end">
                                                                            <button
                                                                            disabled={
                                                                                loadingReplyForm // disable while sending data
                                                                                || replyBodyText === null // disable if reply body is not set yet
                                                                                || replyBodyText.trim() === "" // disable if reply body is empty
                                                                            }
                                                                            className="btn py-2 py-lg-1 px-4 mds-btn mds-fs-4 mds-fw-md mds-btn-primary">
                                                                                Share Advice
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {replyError && <p className="text-danger text-align-left">{replyError}</p>}
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div></div>
                                        }

                                            <div id="post-replies" className="mds-fw-lg mds-fs-lg mb-4">
                                                {post.countReplies + (post.countReplies > 1 ? " Replies" : " Reply")}
                                            </div>
                                            <div className="row row-cols-1 gy-3 mb-3">
                                                {replies.map((reply, index) => {
                                                    return (
                                                        <Reply key={reply._id} replyData={reply} loggedInUser={loggedInUser} index={index} />
                                                    )
                                                })}
                                        </div>
                                        {!loggedInUser ?
                                            <div className="d-flex justify-content-center align-items-center">

                                                <div className="flex-fill card mds-card mx-auto px-3 py-2 my-4" style={{ maxWidth: "600px" }}>
                                                    <div className="card-body">
                                                        <div className="text-center h4 pb-3">Please login to reply</div>
                                                        <div className="d-flex justify-content-center align-items-center gap-3">
                                                            <button onClick={() => { handleRedirectToLoginPage(); }} className="btn flex-fill mds-btn-outline-primary">
                                                                Login
                                                            </button>
                                                            <button onClick={() => { handleRedirectToSignupPage(); }} className="btn flex-fill mds-btn-primary ">
                                                                Signup
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div></div>
                                        }

                                    </div>

                                        
                                        <Modal show={showModalEditPost} onHide={handleHideModalEditPost}
                                            contentClassName="mds-rounded mds-bg-white border mds-border-primary-light mds-modal-shadow"
                                            className="mds-modal pt-5 "
                                            fullscreen="md-down"
                                            size="lg"
                                        >
                                            <Modal.Body className=" mds-rounded">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h5 className="m-0  text-center">Edit Post</h5>
                                                    <button onClick={handleHideModalEditPost} className="btn p-0 px-1 mds-text-primary mds-bg-primary-muted"><MdClose /></button>
                                                </div>
                                                <div className="d-flex justify-content-start align-items-center gap-2 mb-2">
                                                    <div className="d-flex align-items-center">
                                                        <span>
                                                            {post.userId.imageUrl ?
                                                                <Image layout="fixed" className="border mds-border-primary-light rounded-circle" src={post.userId.imageUrl} width={40} height={40} />
                                                                :
                                                                <Avatar name={post.userId.fullName} size={40} round />
                                                            }                                </span>
                                                    </div>
                                                <div className="d-flex flex-column justify-content-center align-items-start gap-0">
                                                    <span className="mds-fw-md text-capitalize  mds-text-dark text-nowrap">
                                                        <Link href={`/u/${post.userId.username}`}>
                                                            <a className="mds-text-primary">
                                                                {post.userId.fullName}
                                                            </a>
                                                        </Link>
                                                    </span>
                                                    {/* <span className="text-muted mds-fs-sm">Product Designer @cliff.ai</span> */}
                                                </div>
                                                </div>
                                                <form ref={formEditPost} onSubmit={(e) => { e.preventDefault(); handleSubmitFormEditPost(); }}>
                                                    <div className="mb-3">
                                                        <Form.Group controlId="title">
                                                            <Form.Label>Title</Form.Label>
                                                            <Form.Control
                                                                required
                                                                className="mds-form-control-white"
                                                                type="text" name="title"
                                                                value={editPostTitle}
                                                                onChange={e => setEditPostTitle(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                    <div className="mb-3">
                                                        <EditorContent className="border mds-editor p-3 mds-rounded-md mds-border-primary-light" editor={editPostEditor} />
                                                    </div>
                                                </form>
                                                {errorEditPost &&
                                                    <div className="text-danger py-3">
                                                        {errorEditPost}
                                                    </div>
                                                }
                                            </Modal.Body>
                                            <Modal.Footer className="border-0">
                                                <div className="d-flex w-100 justify-content-end gap-2 align-items-center">
                                                    <button type="button" onClick={handleHideModalEditPost}
                                                        className="btn  flex-grow-1 flex-md-grow-0 mds-btn px-5 mds-fw-md mds-btn-outline-primary-light">Cancel</button>
                                                    <button disabled={loadingEditPostForm} onClick={handleSubmitFormEditPost}
                                                        className="btn flex-grow-1 text-nowrap flex-md-grow-0 mds-btn px-3 mds-btn-primary mds-fw-md">Save Changes</button>
                                                </div>
                                            </Modal.Footer>
                                        </Modal>

                                        <Modal show={showModalDeletePost} onHide={() => setShowModalDeletePost(false)}
                                            contentClassName="mds-rounded mds-bg-white border mds-border-primary-light mds-modal-shadow"
                                            className="mds-modal pt-5"
                                        >
                                            <Modal.Body className="py-4 mds-rounded">
                                                {postDeletedSuccess ?
                                                    <h5 className="text-center">Post Deleted Successfully !</h5>
                                                    :
                                                    <>
                                                        <div className="d-flex justify-content-center align-items-center mb-3">
                                                            <h5 className="m-0  text-center">Do you want to delete post ?</h5>
                                                        </div>
                                                        <div className="d-flex justify-content-center gap-3 align-items-center">
                                                            <button disabled={loadingDeletePost} type="button" onClick={() => setShowModalDeletePost(false)} className="btn mds-btn px-5 mds-fw-md mds-btn-outline-primary-light">Cancel</button>
                                                            <button disabled={loadingDeletePost} onClick={handleDeletePost} type="button" className="btn mds-btn px-5 mds-btn-primary mds-fw-md">Delete</button>
                                                        </div>
                                                    </>

                                                }
                                            </Modal.Body>
                                        </Modal>

                                        <Modal show={showModalDeleteReply} onHide={() => setShowModalDeleteReply(false)}
                                            contentClassName="mds-rounded mds-bg-white border mds-border-primary-light mds-modal-shadow"
                                            className="mds-modal pt-5"
                                        >
                                            <Modal.Body className="py-4  mds-rounded ">
                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                    <h5 className="m-0  text-center">Do you want to delete reply ?</h5>
                                                    {/* <button className="btn p-0 px-1 mds-text-primary mds-bg-primary-muted"><MdClose /></button> */}
                                                </div>
                                                <div className="d-flex justify-content-center gap-3 align-items-center">
                                                    <button disabled={loadingDeleteReply} type="button" onClick={() => setShowModalDeleteReply(false)} className="btn mds-btn px-5 mds-fw-md mds-btn-outline-primary-light">Cancel</button>
                                                    <button disabled={loadingDeleteReply} onClick={handleDeleteReply} type="button" className="btn mds-btn px-5 mds-btn-primary mds-fw-md">Delete</button>
                                                </div>
                                            </Modal.Body>
                                        </Modal>

                                        <Modal show={showModalReportPost} onHide={handleHideModalReportPost}
                                            contentClassName="mds-rounded border mds-border-primary-light mds-bg-white mds-modal-shadow"
                                            className="mds-modal pt-5"
                                        >
                                            <Modal.Body className="mds-rounded">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h5 className="m-0  text-center">Report an issue</h5>
                                                    <button onClick={handleHideModalReportPost} className="btn p-0 px-1 mds-text-primary mds-bg-primary-muted"><MdClose /></button>
                                                </div>
                                                <p className="m-0 py-3 text-muted">Help us understand the problem. What is wrong with this post ?</p>
                                                <form className="mds-form" ref={formReportPost} onSubmit={handleSubmitFormReportPost}>
                                                    {['Illegal services', 'Hate', 'Misinformation', 'Spam', 'Others'].map(item => (
                                                        <div key={item} className="form-check">
                                                            <input
                                                                onClick={() => setReportType(item)}
                                                                className="form-check-input" type="radio" value={item} name="type" id={item} required />
                                                            <label className="form-check-label" htmlFor={item}>
                                                                {item}
                                                            </label>
                                                        </div>
                                                    ))}
                                                    <input className="form-control mt-2" type={reportType === "Others" ? "text" : "hidden"} name="comment" placeholder="Mention the reason here" required />
                                                    <div className="d-grid mt-3">
                                                        <button disabled={loadingReportPost} className="btn mds-btn btn-lg mds-btn-primary mds-fw-md">
                                                            Report
                                                        </button>
                                                    </div>
                                                </form>
                                            </Modal.Body>
                                        </Modal>

                                        <Modal
                                            show={showLikesModal}
                                            onHide={() => setShowLikesModal(false)}
                                            contentClassName="mds-rounded border mds-border-primary-light mds-bg-white mds-modal-shadow"
                                            className="mds-modal pt-5"
                                        >
                                            <Modal.Body className="mds-rounded">
                                                <div className="card bg-transparent border-0">
                                                    {loadingLikesModal ?
                                                        <div className="d-flex justify-content-center align-items-center gap-3">

                                                            <Spinner animation="border" className="mds-text-primary" />
                                                            <span className="mds-fw-4 mds-fw-lg">Getting Likes ...</span>
                                                        </div>
                                                        :
                                                        <>
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <h5 className="m-0 mds-fs-4 mds-fw-md text-center">{likesData?.length} people liked it</h5>
                                                                    <button onClick={() => setShowLikesModal(false)} className="btn p-0 px-1 mds-text-primary mds-bg-primary-muted"><MdClose /></button>
                                                                </div>
                                                            </div>
                                                            <div className="list-group list-group-flush mds-list-group-flush">
                                                                {likesData?.map(item =>
                                                                    <div key={item._id}
                                                                        className="list-group-item"
                                                                    >
                                                                        <div className="d-flex justify-content-start align-items-center gap-3">
                                                                            {item.imageUrl ?
                                                                                <Image layout="fixed" className="border mds-border-primary-light rounded-circle" src={item.imageUrl} width={40} height={40} />
                                                                                :
                                                                                <Avatar name={item.fullName} size={40} round />
                                                                            }
                                                                            <span className="mds-fs-4 text-capitalize text-nowrap">{item.fullName}</span>
                                                                        </div>
                                                                    </div>)}
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </Modal.Body>
                                        </Modal>
                                    </>

}
                    </>
            }
            </PostContext.Provider>
    )
}


export default Post;


export const getServerSideProps = async (context) => {
    const { query } = context;
    const { slug } = query;

    //get post data
    var postData = await callBackendApi({
        context,
        method: "get",
        url: '/community/posts/' + slug,
        params : {includeReplies : true}
    })
        .then((response) => {
            return response.data.data
        })

    return {
        props: {
            post: postData
        }
    }


}